import {Component, OnInit} from '@angular/core';
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {LocaleStorageService} from "../../common/locale-storage.service";
import {MatFormField, MatFormFieldModule} from "@angular/material/form-field";
import {MatOption, MatSelect, MatSelectChange} from "@angular/material/select";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-language-chooser',
  imports: [
    MatFormField,
    TranslatePipe,
    MatSelect,
    FormsModule,
    MatOption,
    MatFormFieldModule
  ],
  templateUrl: './language-chooser.component.html',
  styleUrl: './language-chooser.component.scss'
})
export class LanguageChooserComponent implements OnInit {
  constructor(private translate: TranslateService,
              private localeStorageService: LocaleStorageService,) {
  }
  availableLanguages: string[] = ["en-US", "en-GB", "de-DE"];
  currentLanguage: string | undefined;
  ngOnInit() {
    const lang = localStorage.getItem('userLanguage');
    if (lang) {
      this.currentLanguage = lang.replace(/"/g, "");
    }
  }
  changeLanguage(event: MatSelectChange) {
    console.log('changeLanguage', event.value);
   this.localeStorageService.setItem('userLanguage', event.value);
   this.translate.setDefaultLang(event.value);
  }

}
